require('./bootstrap');

// require('./lib/jquery.min')
require('./lib/jquery.maskedinput.min')
require('./lib/slick.min')
require('./lib/sweetalert.min')

require('./modules/animation');
require('./modules/auth');
require('./modules/common');
require('./modules/core');
require('./modules/map');
require('./modules/account');
require('./modules/orders');
require('./modules/register');
require('./modules/reset_password');
require('./modules/search');
require('./modules/deliveries');
require('./modules/review');
require('./modules/emails');
